import { useEffect } from 'react';

/**
 * @returns a Promise that resolves after @param miliseconds
 */
export const wait = (miliseconds: number) => new Promise((resolve) => setTimeout(resolve, miliseconds));

export const PageTitleAndFavicon = ({ title, favicon }: { title?: string | true; favicon?: 'arnold' | 'report' }) => {
  useEffect(() => {
    if (title) {
      document.title = title !== true ? `${title} | Arnold` : 'Arnold';
    }
    if (favicon) {
      const link = document.head.querySelector('link[data-favicon]');
      link?.setAttribute('href', favicon === 'report' ? '/favicon-report.png' : '/favicon.ico');
    }
  }, [title, favicon]);

  return null;
};

export function isElementInViewPort(el: Element) {
  const rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
}
